module.exports = __webpack_public_path__ + "img/bg_02@2x.e85f9b30.png";